import { render, staticRenderFns } from "./AddressActions.vue?vue&type=template&id=84798b04&"
import script from "./AddressActions.vue?vue&type=script&lang=js&"
export * from "./AddressActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports